import { rei } from "@/services/api"

class NaturezaProtocoloService {
  static index (params = null) {
    let query = []

    if (params) {
      if (params.perPage) {
        query.push('perPage=' + params.perPage)
      }

      if (params.page) {
        query.push('page=' + params.page)
      }

      if (params.descricao) {
        query.push('descricao=' + params.descricao)
      }

      return rei.get(`natureza-protocolo?${query.join('&')}`)
        .then(res => res.data)
    }

    return rei.get(`natureza-protocolo`)
      .then(res => res.data)
  }

  static show (id) {
    return rei.get(`natureza-protocolo/${ id }`)
      .then(res => res.data)
  }

  static store (data) {
    return rei.post(`natureza-protocolo`, data)
      .then((res) => res.data)
  }

  static update (id, data) {
    return rei.put(`natureza-protocolo/${id}`, data)
      .then((res) => res.data)
  }

  static destroy (id) {
    return rei.delete(`natureza-protocolo/${id}`)
      .then((res) => res.data)
  }
}

export default NaturezaProtocoloService
